import React from "react";
import { BrowserRouter as Navigate, Route, Routes } from "react-router-dom";
import ROUTES from "./Utils/routesConstants";
import PrivateServiceRoute from "./Routes/PrivateServiceRoute";
import ValidateOtp from "./Components/Login/ValidateOtp";
import GenerateOtp from "./Components/Login/GenerateOtp";
import SnackBar from "./common/SnackBar";
import { useSelector } from "react-redux";
import { Loader } from "./common/Loader";
import PrivateNetworkRoute from "./Routes/PrivateNetworkRoute";
import ProviderProfileDetails from "./Components/NetworkPortal/ProviderProfileDetails/index.js";
import HomePage from "./Components/ServicePortal/Home";
import ProfileDetail from "./Components/ServicePortal/ProfileDetail";
import ProfileVerification from "./Components/ServicePortal/ProfileVerification";
import InfrastructureDetails from "./Components/ServicePortal/InfrastructureDetails";
import Appoinments from "./Components/ServicePortal/Appoinments";
import StaffDetails from "./Components/ServicePortal/StaffDetails";
import PaymentDetails from "./Components/ServicePortal/PaymentDetails";
import Faq from "./Components/ServicePortal/FAQ";
import { ErrorPage404 } from "./common/404ErrorPage";
import HelloAdmin from "./Components/NetworkPortal/HelloAdmin";
import { UnathorizedPage } from "./common/UnathorizedPage";
import TestPackages from "./Components/ServicePortal/TestPackages";
import AppointmentDetailsTemplate from "./Components/ServicePortal/Appoinments/AppointmentDetailsTemplate";
import TestPackagesNetwork from "./Components/NetworkPortal/TestPackages";
import ProviderAssist from "./Components/NetworkPortal/ProviderAssist";
import Dashboard from "./Components/NetworkPortal/NetworkIntelligence/Dashboard";
import UsageCoverage from "./Components/NetworkPortal/NetworkIntelligence/UsageCoverage";
import Settlements, { ClientCoverage } from "./Components/NetworkPortal/NetworkIntelligence/Settlement";
import AdoptionAnalysis from "./Components/NetworkPortal/NetworkIntelligence/AdoptionAnalysis";
import WhatsappAppointmentActions from "./Components/ServicePortal/Appoinments/WhatsappAppointmentActions";
import TestCreation from "./Components/NetworkPortal/TestPackageCreation/TestCreation.js";
import PackageCreation from "./Components/NetworkPortal/TestPackageCreation/PackageCreation.js";
import { PayOut } from "./Components/NetworkPortal/PayOut/index.js";
import { Payable } from "./Components/NetworkPortal/PayOut/Payable.js";
import { PayoutTab } from "./Components/NetworkPortal/PayOut/PayoutTab.js";
import { InsurerBilling } from "./Components/InsurerBilling/index.js";
import { Receivables } from "./Components/InsurerBilling/Receivables.js";
import { InsurerDashboard } from "./Components/InsurerBilling/InsurerDashboard.js";
import PendingReceivables from "./Components/InsurerBilling/PendingReceivables.js";
import { InvoiceGeneration } from "./Components/NetworkPortal/PayOut/InvoiceGeneration.js";
import {AdvancePayment} from "./Components/NetworkPortal/PayOut/AdvancePayment.js"
import { PayoutDashboard } from "./Components/NetworkPortal/PayOut/PayoutDashboard.js";

function App() {
  const { open } = useSelector((state) => state.globalReducer.snackbar);
  return (
    <>
      {open && <SnackBar />}
      <Loader />
      <Routes>
        <Route path="/ProvidersPortal" element={<Navigate to="" replace />} />
        <Route path="" element={<GenerateOtp />} />
        <Route path={ROUTES.VALIDATE_OTP} element={<ValidateOtp />} />
        <Route
          path="/campaigns/SKUPackageCampaign/:token"
          element={<TestPackages/>}
        />
        <Route
          path="/campaigns/UpdateLogo/:token"
          element={
          <InfrastructureDetails/>}
        />
        <Route
          path="/campaigns/UpdateProfile/:token"
          element={<ProviderAssist/>}
        />
        <Route
          path={`/appointmentdetailstemplate/:ele`}
          element={<AppointmentDetailsTemplate />}
        />
        <Route
          path={`/appointmentactions/:source/:token`}
          element={<WhatsappAppointmentActions />}
        />
        <Route path={ROUTES.UNATHORIZED} element={<UnathorizedPage />} />
        <Route path="*" element={<ErrorPage404 />} replace />
        <Route
          path={ROUTES.HOME}
          element={<PrivateServiceRoute Component={HomePage} />}
        />
        <Route
          path={ROUTES.PROFILE_DETAIL}
          element={<PrivateServiceRoute Component={ProfileDetail} />}
        />
        <Route
          path={ROUTES.PROFILE_VERIFICATION}
          element={<PrivateServiceRoute Component={ProfileVerification} />}
        />
        <Route
          path={ROUTES.INFRASTRUCTURE_DETAILS}
          element={<PrivateServiceRoute Component={InfrastructureDetails} />}
        />
        <Route
          path={ROUTES.PAYMENT_DETAILS}
          element={<PrivateServiceRoute Component={PaymentDetails} />}
        />
        <Route
          path={ROUTES.STAFF_DETAILS}
          element={<PrivateServiceRoute Component={StaffDetails} />}
        />
        <Route
          path={ROUTES.FAQ}
          element={<PrivateServiceRoute Component={Faq} />}
        />
        <Route
          path={ROUTES.APPOINMENTS}
          element={<PrivateServiceRoute Component={Appoinments} />}
        />
        <Route
          path={ROUTES.TESTS_PACKAGES}
          element={<PrivateServiceRoute Component={TestPackages} />}
        />
        <Route
          path={ROUTES.PROVIDER_PROFILE_DETAILS}
          element={<PrivateNetworkRoute Component={ProviderProfileDetails} />}
        />
        <Route
          path={ROUTES.HELLO_ADMIN}
          element={<PrivateNetworkRoute Component={HelloAdmin} />}
        />
        <Route
          path={ROUTES.APPOINMENT_MANAGEMENT}
          element={<PrivateNetworkRoute Component={Appoinments} />}
        />
        <Route
          path={ROUTES.TEST_PACKAGES_PROVIDERMAPPING}
          element={<PrivateNetworkRoute Component={TestPackagesNetwork} />}
        />
        <Route
          path={ROUTES.TEST_PACKAGES_TESTCREATION}
          element={<PrivateNetworkRoute Component={TestCreation} />}
        />
        <Route
          path={ROUTES.TEST_PACKAGES_PACKAGECREATION}
          element={<PrivateNetworkRoute Component={PackageCreation} />}
        />
        <Route
          path={ROUTES.PROVIDER_ASSIST}
          element={<PrivateNetworkRoute Component={ProviderAssist} />}
        />
        <Route
          path={ROUTES.NETWORK_INTELLIGENCE_DASHBOARD}
          element={<PrivateNetworkRoute Component={Dashboard} />}
        />
        <Route
          path={ROUTES.NETWORK_INTELLIGENCE_USAGECOVERAGE}
          element={<PrivateNetworkRoute Component={UsageCoverage} />}
        />
        <Route
          path={ROUTES.NETWORK_INTELLIGENCE_SETTLEMENTS}
          element={<PrivateNetworkRoute Component={ClientCoverage} />}
        />
        <Route
          path={ROUTES.NETWORK_INTELLIGENCE_ADOPTION_ANALYSIS}
          element={<PrivateNetworkRoute Component={AdoptionAnalysis} />}
        />
        <Route
          path={ROUTES.NETWORK_PAYOUT}
          element={<PrivateNetworkRoute Component={PayoutTab} />}
        />
        <Route
          path={ROUTES.NETWORK_PAYABLES}
          element={<PrivateNetworkRoute Component={Payable} />}
        />
        <Route
          path={ROUTES.INSURER_BILLING}
          element={<PrivateNetworkRoute Component={InsurerBilling} />}
        />
        <Route
          path={ROUTES.INSURER_RECEIVABLES}
          element={<PrivateNetworkRoute Component={Receivables} />}
        />
        <Route
          path={ROUTES.INSURER_DASHBOARD}
          element={<PrivateNetworkRoute Component={InsurerDashboard} />}
        />
        <Route
          path={ROUTES.INSURER_PENDING_RECEIVABLES}
          element={<PrivateNetworkRoute Component={PendingReceivables} />}
        />
        <Route
          path={ROUTES.INSURER_INVOICE_GENERATION}
          element={<PrivateNetworkRoute Component={InvoiceGeneration} />}
        />
        <Route
          path={ROUTES.ADVANCE_PAYMENT}
          element={<PrivateNetworkRoute Component={AdvancePayment} />}
        />
        <Route
          path={ROUTES.NETWORK_PAYOUT_DASH}
          element={<PrivateNetworkRoute Component={PayoutDashboard} />}
        />
      </Routes>
    </>
  );
}

export default App;
